"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockProperty = exports.infoBlockPropertyDefinition = void 0;
exports.infoBlockPropertyDefinition = {
    view: { label: 'Info block' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'info-block-title',
                'info-block-description',
                'info-block-label',
                'info-block-url',
                'info-block-image',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'info-block',
};
const isInfoBlockProperty = (prop) => {
    return prop.name === exports.infoBlockPropertyDefinition.name;
};
exports.isInfoBlockProperty = isInfoBlockProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2luZm8tYmxvY2sucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBT2EsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsWUFBWSxFQUFFO0lBQzdCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUU7Z0JBQ1Isa0JBQWtCO2dCQUNsQix3QkFBd0I7Z0JBQ3hCLGtCQUFrQjtnQkFDbEIsZ0JBQWdCO2dCQUNoQixrQkFBa0I7YUFDbkI7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxZQUFZO0NBQ2EsQ0FBQTtBQVkxQixNQUFNLG1CQUFtQixHQUFHLENBQUMsSUFBa0IsRUFBNkIsRUFBRTtJQUNuRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssbUNBQTJCLENBQUMsSUFBSSxDQUFBO0FBQ3ZELENBQUMsQ0FBQTtBQUZZLFFBQUEsbUJBQW1CLHVCQUUvQiJ9